import * as React from 'react'
import { BulkActionButton } from '../BulkActionButton'

type Props = { hasPermission: boolean }
export const BulkCloseWinButton: React.FC<Props> = (props) => (
  <BulkActionButton
    type="closeWin"
    helperText="Close/Win records in bulk. Records must be in an open state to perform this action."
    hasPermission={props.hasPermission}
    errorString="You do not have permission to perform bulk close/wins."
    dataTestId="closewin"
  >
    Close/Win
  </BulkActionButton>
)
BulkCloseWinButton.displayName = 'BulkCloseWinButton'
